
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bookings",
      function () {
        return require("private-next-pages/bookings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bookings"])
      });
    }
  